<div class="header">
  <div class="title">
    <label>{{quickQuote.header}}</label>
    <p>Need assistance? Call us <a href="tel:+443300100210">0330 010 0210</a></p>
  </div>
  <div class="app-progress">
    <div *ngIf="progress$ | async as pages" class="items">
      <div *ngFor="let page of pages; let i = index" class="item" [class.unticked]="!page.complete">
        <div class="label">
          <label>Step {{i+1}}</label>
          <label>{{page.step}}</label>
        </div>
      </div>
    </div>
  </div>
</div>